(function () {
  if (customElements.get("featured-collection-slider")) return;

  // Helper promise to resolve as soon as Splide assets load
  window.SplideLoaded =
    window.SplideLoaded ||
    new Promise((resolve) => {
      if (window.Splide) {
        resolve();
      } else {
        // Check if the script exists and listen for load, otherwise fallback to polling
        const script = document.querySelector('script[src*="splide.min.js"]');
        if (script) {
          script.addEventListener("load", () => resolve());
          script.addEventListener("readystatechange", () => {
            if (
              script.readyState === "complete" ||
              script.readyState === "loaded"
            )
              resolve();
          });
        } else {
          const interval = setInterval(() => {
            if (window.Splide) {
              clearInterval(interval);
              resolve();
            }
          }, 50);
        }
      }
    });

  class FeaturedCollectionSlider extends HTMLElement {
    connectedCallback() {
      this.initSlider();

      // Shopify Theme Editor Listeners for section load/unload to guarantee smooth re-initialization
      this.onSectionLoadHandler = this.onSectionLoad.bind(this);
      this.onSectionUnloadHandler = this.onSectionUnload.bind(this);
      document.addEventListener(
        "shopify:section:load",
        this.onSectionLoadHandler,
      );
      document.addEventListener(
        "shopify:section:unload",
        this.onSectionUnloadHandler,
      );
    }

    disconnectedCallback() {
      this.destroySlider();
      document.removeEventListener(
        "shopify:section:load",
        this.onSectionLoadHandler,
      );
      document.removeEventListener(
        "shopify:section:unload",
        this.onSectionUnloadHandler,
      );
    }

    onSectionLoad(event) {
      if (event.target.contains(this) || event.target === this) {
        this.initSlider();
      }
    }

    onSectionUnload(event) {
      if (event.target.contains(this) || event.target === this) {
        this.destroySlider();
      }
    }

    initSlider() {
      window.SplideLoaded.then(() => {
        this.mountSplide();
      });
    }

    mountSplide() {
      this.destroySlider();

      const splideEl = this.querySelector(".splide");
      if (!splideEl) return;

      this.splide = new Splide(splideEl, {
        type: "slide",
        perPage: 5,
        perMove: 1,
        gap: "18px",
        arrows: false,
        pagination: true,
        drag: true,

        breakpoints: {
          1440: {
            gap: "10px",
          },
          1280: {
            perPage: 4,
            perMove: 1,
          },
          990: {
            perPage: 3,
            perMove: 1,
          },
          600: {
            perPage: 2,
          },
        },
      });

      this.splide.mount();
    }

    destroySlider() {
      if (this.splide) {
        this.splide.destroy();
        this.splide = null;
      }
    }
  }

  customElements.define("featured-collection-slider", FeaturedCollectionSlider);
})();
